<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>This book is dedicated to the good people of Barelas …</i></span></p>
<p class="ded1"><span><i>and to people everywhere who have struggled for</i></span></p>
<p class="ded1"><span><i>freedom, dignity, and the right of self-determination</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?24e69d47